import 'twin.macro'

export default function Container({ children, ...rest }) {
  return (
    <div {...rest} tw="max-w-8xl mx-auto px-5 lg:px-9">
      {children}
    </div>
  )
}
